import { MeDocument } from '@stack/data-access';
import { retrieveAuthTokenFromContext } from '@webbyx/next-js';
import fetch from 'isomorphic-unfetch';

import { GRAPHQL_ENDPOINT } from './constant';

export const checkAuthProfile = async (context?: any): Promise<any> => {
  const token = retrieveAuthTokenFromContext(context);
  if (!token) return Promise.resolve(null);
  const query = MeDocument?.loc?.source?.body ?? {};
  const res = await fetch(GRAPHQL_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      query,
    }),
  });
  const result = await res.json();
  return result?.data?.Me ?? null;
};

export default checkAuthProfile;
